import React from 'react';
const Download = () => {
  return (
    <div className="rollingContent">
      <div className="contentImage05">
          <div className="contentImage04-txt01"><img src={require('../images/rolling04-txt01.png')} alt="rolling04-txt01"/></div>
          <div className="contentImage04-txt02"><img src={require('../images/rolling04_1.png')} alt="rolling04_1"/></div>
          <div className="contentImage04-txt03"><img src={require('../images/rolling04_2.png')} alt="rolling04_2" /></div>
          <div className="contentImage04-txt04"><img src={require('../images/rolling04_3.png')} alt="rolling04_3"/></div>
      </div>
    </div>
  );
}

export default Download;
